import { render } from "./NftAppSvg.vue?vue&type=template&id=061d7570&ts=true"
import script from "./NftAppSvg.vue?vue&type=script&lang=ts"
export * from "./NftAppSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__